import { rowHasAudio, withAudioFlag } from "./row-has-audio";

const CONCURRENCY = 5;

export const mergeAudioDetail = (rows: any[], id: any, detail: any) => {
    const index = (rows || []).findIndex((row) => row.id === id);
    if (index === -1 || !detail) return rows;

    const current = rows[index];
    const hasaudio = Boolean(detail.hasaudio || detail.s3uri);
    const next = rows.slice();

    next[index] = withAudioFlag({
        ...current,
        hasaudio,
        s3uri: detail.s3uri || current.s3uri,
        surveyor_name: detail.sr?.username || current.surveyor_name,
        meta: {
            ...current.meta,
            hasaudio,
        },
    });

    return next;
};

export const hydrateAudioFlags = async (store: any) => {
    const pending = (store.allSurveyResponses || []).filter((row) => row?.id && !rowHasAudio(row));
    if (!pending.length) return;

    let cursor = 0;

    const worker = async () => {
        while (cursor < pending.length) {
            const row = pending[cursor];
            cursor += 1;

            try {
                const response = await store.rootStore.api.post("survey/getbyidwithoutaudio", {
                    clientid: row.id,
                });
                store.applyAudioFromDetail(row.id, response?.data);
            } catch (error) {
                console.error(error);
            }
        }
    };

    const workers = Math.min(CONCURRENCY, pending.length);
    await Promise.all(Array.from({ length: workers }, () => worker()));
};
